import httpClient from "../../../services/http";

export const getSiteNotification = () =>
    httpClient.get('/utils-service/site-notification');